import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import zhTranslations from './locales/zh.json';
import esTranslations from './locales/es.json';

const resources = {
  en: {
    translation: enTranslations
  },
  zh: {
    translation: zhTranslations
  },
  es: {
    translation: esTranslations
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    
    // Default language
    fallbackLng: 'en',
    
    // Language detection settings
    detection: {
      // Detection order
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache user language on localStorage
      caches: ['localStorage'],
      
      // Look for language in these localStorage keys
      lookupLocalStorage: 'i18nextLng',
      
      // Don't lookup language in cookie
      lookupCookie: false,
    },

    // Enable debug mode in development
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      // React already does escaping
      escapeValue: false,
    },

    // Return key if translation is missing
    returnKeyIfError: true,
    returnNull: false,
    returnEmptyString: false,

    // Namespace settings
    defaultNS: 'translation',
    ns: ['translation'],

    // Pluralization
    pluralSeparator: '_',
    contextSeparator: '_',

    // Load only current language
    load: 'currentOnly',
    
    // Preload languages
    preload: ['en'],
    
    // Clean code
    cleanCode: true,
    
    // Language codes
    supportedLngs: ['en', 'zh', 'es'],
    nonExplicitSupportedLngs: false,
  });

export default i18n;